export default __webpack_public_path__ + "f45c6de8f1b73b877f766bb0eacc969e.png";